module.exports = require("log-symbols");


//////////////////
// WEBPACK FOOTER
// external "log-symbols"
// module id = 55
// module chunks = 0